import styles from "./questionItem.module.scss";

export const QuestionItem = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";

  const prepareImageUrl = (url: string) => {
    return `${url}?w=256`;
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["imgContainer"]}>
        <img
          loading="lazy"
          src={prepareImageUrl(props.imageUrl)}
          alt={props.imgAlt}
        />
      </div>
      <div className={styles["contentContainer"]}>
        <div className={styles["courseName"]}>{props.courseName}</div>
        <LinkComponent href={props.url} className={styles["subjectName"]}>
          {props.subjectName}
        </LinkComponent>
        <div className={styles["description"]}>{props.description}</div>
      </div>
    </div>
  );
};

interface Props {
  imageUrl: string;
  courseName: string;
  subjectName: string;
  description: string;
  url: string;
  imgAlt: string;
  linkAs?: React.ElementType;
}
